import { useTranslation } from 'react-i18next';

// Colorful gradient icons for each service
const serviceIcons = {
  'vehicle-repair-maintenance': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="repair-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
      </defs>
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="url(#repair-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'car-scanning-diagnostics': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="scan-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#ec4899" />
        </linearGradient>
      </defs>
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="url(#scan-grad)" strokeWidth="2"/>
      <path d="M7 8h10M7 12h10M7 16h6" stroke="url(#scan-grad)" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  'major-minor-service': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="service-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      <path d="M9 2v4M15 2v4M9 22v-4M15 22v-4M2 9h4M22 9h-4M2 15h4M22 15h-4" stroke="url(#service-grad)" strokeWidth="2" strokeLinecap="round"/>
      <rect x="7" y="7" width="10" height="10" rx="2" stroke="url(#service-grad)" strokeWidth="2"/>
    </svg>
  ),
  'car-ac-services': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="ac-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>
      </defs>
      <path d="M12 2v4M12 18v4M17.66 5.34l-2.83 2.83M9.17 13.83l-2.83 2.83M22 12h-4M6 12H2M17.66 18.66l-2.83-2.83M9.17 10.17l-2.83-2.83" stroke="url(#ac-grad)" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="12" cy="12" r="3" stroke="url(#ac-grad)" strokeWidth="2"/>
    </svg>
  ),
  'premium-oil-services': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="oil-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#ef4444" />
        </linearGradient>
      </defs>
      <path d="M12 2L8 6h8l-4-4zM8 6v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6M10 14h4" stroke="url(#oil-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'car-denting-painting': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="paint-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ec4899" />
          <stop offset="100%" stopColor="#f59e0b" />
        </linearGradient>
      </defs>
      <path d="M4 20h16M6 16l2-2 4 4 7-7 2 2M18 3l3 3-9 9-3-3 9-9z" stroke="url(#paint-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'car-battery-services': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="battery-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#f59e0b" />
        </linearGradient>
      </defs>
      <rect x="2" y="7" width="20" height="10" rx="2" stroke="url(#battery-grad)" strokeWidth="2"/>
      <path d="M22 10v4M7 10v4M11 10v4" stroke="url(#battery-grad)" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  'car-brakes-services': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="brake-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ef4444" />
          <stop offset="100%" stopColor="#dc2626" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="10" stroke="url(#brake-grad)" strokeWidth="2"/>
      <circle cx="12" cy="12" r="4" stroke="url(#brake-grad)" strokeWidth="2"/>
      <path d="M12 2v4M12 18v4M22 12h-4M6 12H2" stroke="url(#brake-grad)" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  'car-brakes-suspension': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="suspension-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      <path d="M12 2v8M8 6L12 10l4-4M12 10v4M8 18h8M10 14h4v8h-4v-8z" stroke="url(#suspension-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'car-engine-repair': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="engine-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="100%" stopColor="#ef4444" />
        </linearGradient>
      </defs>
      <rect x="4" y="6" width="16" height="12" rx="2" stroke="url(#engine-grad)" strokeWidth="2"/>
      <path d="M8 2v4M16 2v4M12 6v4M8 14h8M2 10h2M20 10h2" stroke="url(#engine-grad)" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  'car-transmission-repair': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="trans-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#14b8a6" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
      </defs>
      <circle cx="8" cy="12" r="4" stroke="url(#trans-grad)" strokeWidth="2"/>
      <circle cx="16" cy="12" r="4" stroke="url(#trans-grad)" strokeWidth="2"/>
      <path d="M12 12h4M8 8L16 8M8 16h8" stroke="url(#trans-grad)" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  'tyre-replacement': (
    <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="tyre-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#64748b" />
          <stop offset="100%" stopColor="#475569" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="10" stroke="url(#tyre-grad)" strokeWidth="2"/>
      <circle cx="12" cy="12" r="6" stroke="url(#tyre-grad)" strokeWidth="2"/>
      <circle cx="12" cy="12" r="2" fill="url(#tyre-grad)"/>
      <path d="M12 2v4M12 18v4M22 12h-4M6 12H2M18.36 5.64l-2.83 2.83M8.47 15.53l-2.83 2.83M18.36 18.36l-2.83-2.83M8.47 8.47L5.64 5.64" stroke="url(#tyre-grad)" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
};

export default function ServicesSection({ compact=false }) {
  const { t } = useTranslation();
  
  const services = [
    {
      title: t('services.vehicleRepair'),
      slug: 'vehicle-repair-maintenance',
      desc: t('services.vehicleRepair.desc')
    },
    {
      title: t('services.carScanning'),
      slug: 'car-scanning-diagnostics',
      desc: t('services.carScanning.desc')
    },
    {
      title: t('services.majorMinor'),
      slug: 'major-minor-service',
      desc: t('services.majorMinor.desc')
    },
    {
      title: t('services.carAC'),
      slug: 'car-ac-services',
      desc: t('services.carAC.desc')
    },
    {
      title: t('services.premiumOil'),
      slug: 'premium-oil-services',
      desc: t('services.premiumOil.desc')
    },
    {
      title: t('services.denting'),
      slug: 'car-denting-painting',
      desc: t('services.denting.desc')
    },
    {
      title: t('services.battery'),
      slug: 'car-battery-services',
      desc: t('services.battery.desc')
    },
    {
      title: t('services.brakes'),
      slug: 'car-brakes-services',
      desc: t('services.brakes.desc')
    },
    {
      title: t('services.brakesSuspension'),
      slug: 'car-brakes-suspension',
      desc: t('services.brakesSuspension.desc')
    },
    {
      title: t('services.engine'),
      slug: 'car-engine-repair',
      desc: t('services.engine.desc')
    },
    {
      title: t('services.transmission'),
      slug: 'car-transmission-repair',
      desc: t('services.transmission.desc')
    },
    {
      title: t('services.tyre'),
      slug: 'tyre-replacement',
      desc: t('services.tyre.desc')
    }
  ];
  return (
    <section id="services" className="py-6 md:py-12 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {!compact && (
          <div className="mb-12 text-center">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">{t('services.title')}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">{t('services.subtitle')}</p>
          </div>
        )}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map(s => (
            <a
              key={s.title}
              href={`/services/${s.slug}`}
              className="group relative p-6 rounded-2xl border border-gray-200 hover:border-[#F5D313] hover:shadow-xl transition-all duration-300 bg-white/80 backdrop-blur flex flex-col overflow-hidden"
            >
              {/* Glow effect on hover */}
              <span className="pointer-events-none absolute -inset-1 rounded-2xl bg-gradient-to-br from-[#F5D313]/0 to-[#F5D313]/0 group-hover:from-[#F5D313]/20 group-hover:to-transparent blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              {/* Icon container with gradient background */}
              <div className="relative mb-4 w-16 h-16 rounded-xl bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-white/50 to-transparent" />
                {serviceIcons[s.slug]}
              </div>
              
              <h3 className="relative font-semibold text-lg mb-2 text-gray-800 group-hover:text-gray-900 transition-colors">
                {s.title}
              </h3>
              <p className="relative text-sm text-gray-600 leading-relaxed flex-1">{s.desc}</p>
              <span className="relative mt-4 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-slate-500 group-hover:text-[#F5D313] transition-colors">
                {t('common.learnMore')}
                <svg className="w-3 h-3 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6" /></svg>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
